<template>
  <!-- Seilzugflächen-->
  <span v-for="(seilzugflaeche, szfKey) in getSeilzugflaechen(ba)" :key="szfKey">
  <!-- Seilzugfläche Allgemein Page -->
    <pdf-a4-page no-margin :pdf-key="lang"> 
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500">Seilzugfläche {{ szfKey + 1 }} > Allgemein > Allgemeine Punkte</div>
          <div class="text-xl md:text-xl font-bold">Seilzugfläche {{ szfKey + 1 }} ({{ seilzugflaeche.findFrageByRelativePath(ba, 'allgemein-modal.allgemein-group.typ')?.getSelectedAuswahlLabelsString()  }})</div>
          <div class="content h-full max-h-full">
            <!-- Allgemein -->
              <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="text-lg md:text-lg col-span-8">Allgemeine Punkte</div>
              <div
                class="col-span-2 text-sm font-bold"
                style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
              >
                Frage
              </div>
              <div
                class="text-sm font-bold col-span-6"
                style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
              >
                Beschreibung/Eingabewerte
              </div>
  
              <!-- Entfernung Mast start-->
              <div class="text-xs col-span-2">Seilzug von/nach Mast:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{seilzugflaeche.findFrageByRelativePath(ba,'allgemein-modal.allgemein-group.seilzugvonmast')?.['eingabeText'] }}
              </div>
              <div class="text-xs col-span-2">Abspannabschnittlänge:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ 
                  seilzugflaeche.findFrageByRelativePath(ba, 'allgemein-modal.allgemein-group.abspannabschnittlaenge')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(ba, 'allgemein-modal.allgemein-group.abspannabschnittlaenge')?.['eingabeText'] + " m" 
                    : "-" 
                }}
              </div>
              <div class="text-xs col-span-2">Seilzugfläche Erfordernisse:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{seilzugflaeche.findFrageByRelativePath(ba,'allgemein-modal.allgemein-group.erfordnerisse')?.getSelectedAuswahlLabelsString()}}
              </div>
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="allgemein-modal.allgemein-group.flaeche-vorhanden"
                label="Fläche zwischen Mast und Seilzugfläche vorhanden"
                class="col-span-8"
              />
            </div>
            <br>
            <div class="grid gap-0 grid-cols-3 p-0 m-0">
              <div><hr class="trenner" /></div>
              <div class="mt-0.5"><hr class="trenner" /></div>
              <div><hr class="trenner" /></div>
            </div>
            <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Seilzugfläche > Allgemeine Punkte</div>
            <div class="text-xl md:text-xl font-bold">Seilzugfläche</div>
            <!-- Allgemeine Punkte Start-->
            <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="text-lg md:text-lg col-span-8">Allgemeine Punkte</div>
              <div
                class="col-span-2 text-sm font-bold"
                style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
              >
                Frage
              </div>
              <div
                class="text-sm font-bold col-span-6"
                style="border-style:solid;border-color:white white rgb(216,215,26);border-radius: 5px;"
              >
                Beschreibung/Eingabewerte
              </div>
              <!-- Entfernung Mast start-->
              <div class="text-xs col-span-2">Soll-Entfernung zum Mastmittelpunkt:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ 
                  seilzugflaeche.findFrageByRelativePath(ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-soll')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-soll')?.['eingabeText'] + " m" 
                    : "-" 
                }}
              </div>
              <div class="text-xs col-span-2">Ist-Entfernung zum Mastmittelpunkt:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ 
                  seilzugflaeche.findFrageByRelativePath(ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-ist')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-ist')?.['eingabeText'] + " m" 
                    : "-" 
                }}
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="seilzugflaeche-modal.allgemein.entfernung-mast-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
               />
  
              <!-- Entfernung Mast Ende-->
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyse </div>
              <div class="text-sm font-bold col-span-5" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyseergebnisse</div>
              <div class="col-span-1 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Bewertung</div>
              <!-- Nutzungsart start-->
              <!-- Nutzungsart start-->
              <div class="text-xs col-span-2">Nutzungsarten der Fläche:</div>
              <div class="text-xs text-gray-500 col-span-5">
                <ul
                  v-for="(v, key) in seilzugflaeche.findFrageByRelativePath(ba,
                    'seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche'
                  )?.getSelectedAuswahlLabels()"
                  :key="key"
                  class=""
                >
                  <li :key="key" class="text-xs text-gray-500">{{ v.de }}</li>
                </ul>
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="seilzugflaeche-modal.allgemein.nutzungsart-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
  
              <!-- Nutzungsart Ende-->
              <!-- Fremdobjekte start-->
              <div class="text-xs col-span-2">Fremdobjekte auf Fläche:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText'] }} 
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
  
              <!-- Fremdobjekte Ende-->
              <!-- Weitere Fremdobjekte start-->
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche"
                label="Weitere Fremdobjekte:"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-6">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText'] }} 
              </div>
              <!-- Fremdobjekte Weitere Ende-->
              <!-- Betreiber start-->
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="seilzugflaeche-modal.allgemein.betreiber-vorhanden"
                label="Betreiber Fremdobjekte:"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-6">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString() }} 
              </div>
              <!-- Betreiber Ende-->
              <!-- Flurstuecke start-->
              <div class="text-xs col-span-2">Betroffene Flurstücke</div>
                <div class="text-xs text-gray-500 col-span-5">
                  {{ seilzugflaeche.findFrageByRelativePath(ba, 'seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText'] }}
                </div>
              <!-- Flurstuecke Ende-->
            </div>
  
            <!-- Allgemeine Punkte Ende-->
          </div>   
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a4-page>
    <!-- ###################### -->
    <!-- Seilzugfläche Geländebeschaffenheit Page 1  -->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Seilzugfläche > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Graben)</div>

            <div class="h-full max-h-full">
            <!-- Geländebeschaffenheit Start-->
              <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit (Seilzugfläche)</div>
              <div class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Frage
            </div>
            <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Beschreibung/Eingabewerte
            </div>
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Weitere Eingaben
            </div>
            <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Bewertung
            </div>

            <!-- Gefälle start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden"
              label="Gefälle/Hang/Böschung"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.gefaelle-group.gefaelle-beschreibung')?.['eingabeText']}}
            </div>
            <div class="text-xs">Art:</div>
            <div class="text-xs text-gray-500 col-span-1">
              <span
                v-for="(v, key) in seilzugflaeche.findFrageByRelativePath( ba,
                  'seilzugflaeche-modal.gefaelle-group.gefaelle-boeschung-art'
                )?.getSelectedAuswahlLabels()"
                :key="key"
                class="text-gray-500"
              >
            {{ v.de }}
            </span>
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <!-- todo images gefälle/Hang/Böschung -->
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.gefaelle-group.gefaelle-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            >
            </oneto-five-image-div-mehrfach>

            <!-- Gefälle Ende-->
            
            <!-- Ausholzung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich"
              label="Ausholzung erforderlich"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Art:</div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()  }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.ausholzung-group.ausholzung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Ausholzung Ende-->

            <!-- Rodung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.rodung-group.rodung-erforderlich"
              label="Rodung erforderlich"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Anzahl Bäume:</div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')?.['eingabeText'] }}
            </div>
           
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.rodung-group.rodung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.rodung-group.rodung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            
            <!-- Rodung Ende-->

            <!-- Graben start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.graben-group.graben-vorhanden"
              label="Graben vorhanden"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.graben-group.graben-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Anzahl:</div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.graben-group.graben-anzahl')?.['eingabeText'] }}
            </div>
            
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.graben-group.graben-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.graben-group.graben-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            <!-- Graben Ende-->

          </div>
            </div>
            <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>         
    <!-- ###################### --> 
    <!-- Seilzugfläche Geländebeschaffenheit Page 2  -->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Seilzugfläche > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)</div>
            <div class="h-full max-h-full">
            <!-- Geländebeschaffenheit Start-->
            <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit (Seilzugfläche) - Fortsetzung</div>

                      <div
            class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3"
          >
            <div
              class="col-span-2 text-sm font-bold"
              style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
            >
              Frage
            </div>
            <div
              class="text-sm font-bold col-span-3"
              style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
            >
              Beschreibung/Eingabewerte
            </div>
            <div
              class="col-span-2 text-sm font-bold"
              style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
            >
              Weitere Eingaben
            </div>
            <div
              class="col-span- text-sm font-bold"
              style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
            >
              Bewertung
            </div>
            <!-- Feuchtgebiete start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-vorhanden"
              label="Feuchtgebiete vorhanden"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText'] }}
            </div>

            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            ></bewertung-chip>
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            
            <!-- Feuchtgebiete Ende-->

            <!-- Naturdenkmäler start-->
            <div class="col-span-3">
              <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden"
              label="Naturdenkmäler vorhanden"
                class="col-span-2"
              />
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="seilzugflaeche-modal.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar"
                label="Weitere Naturdenkmäler sichtbar"
                class="col-span-2"
              />
            </div>
            <div class="text-xs text-gray-500 col-span-4">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText'] }}
            </div>

            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            <!-- Naturdenkmäler Ende-->


            <!-- Kampfmittel start-->
             <div class="col-span-2">
               <is-vorhanden-char-and-label
                 :fragenblock="seilzugflaeche"
                 :ba="ba"
                 fragesPath="seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden"
                 label="Kampfmittel vorhanden"
                 class="col-span-2"
               />
               <is-vorhanden-char-and-label
                 :fragenblock="seilzugflaeche"
                 :ba="ba"
                 fragesPath="seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung"
                 label="Freimessung erforderlich"
                 class="col-span-2"
               />
             </div>
             <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Art:</div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')?.['eingabeText'] }}
            </div>

            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            ></bewertung-chip>
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.kampfmittel-group.kampfmittel-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            >
            </oneto-five-image-div-mehrfach>
            <!-- Kampfmittel Ende-->


            <!-- Sonstiges start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden"
              label="Sonstiges vorhanden"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')?.['eingabeText'] }}
            </div>

            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="seilzugflaeche-modal.sonstiges-group.sonstiges-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
          </div>
            </div>
            <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>     
    <!-- ###################### -->
    <!-- Seilzugfläche Ökologie Page und Bilder -->
    <Oekologie :ba="ba" :immobilie="immobilie" :lang="lang" :oekologie="seilzugflaeche.findFragenblockByRelativePath(ba, 'seilzugflaeche-modal.oekologie-group')!" :bread-crumb="`Seilzugfläche ${szfKey + 1} > Ökologie`" tab="Seilzugfläche"/>

    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Allgemeine Bilder</div>
            <div class="h-full max-h-full">
            <div class="mt-4 text-lg md:text-lg">Bilder Seilzugfläche</div>
                <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
                  <div class="col-span-8 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">                  
                  </div>
                <oneto-five-image-div-mehrfach
                  :fragenblock="seilzugflaeche"
                  :ba="ba"
                  :immobilie="immobilie"
                  fragesPath="seilzugflaeche-modal.bilder-group.bilder"
                  :lang="lang"
                  class="col-span-8 ml-2"
                />
                
              </div>

            <br>
            </div>
            <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>
    <!-- Zuwegung Seilzugflaeche -->
    <pdf-a4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Zuwegung Seilzugfläche > Allgemeine Punkte</div>

          <div class="text-xl md:text-xl font-bold">Zuwegung Seilzugfläche</div>
          <div class="content h-full max-h-full">
            <!-- Allgemeine Punkte Start-->
            <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="text-lg md:text-lg col-span-8">Allgemeine Punkte (Zuwegung Seilzugfläche)</div>
<!-- Analyse start-->
              <div class=" col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyse </div>
              <div class=" text-sm font-bold col-span-5" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyseergebnisse</div>
              <div class="col-span-1 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Bewertung</div>
<!--Betroffene Flurstuecke Start-->
              <div class="text-xs md:text-xs col-span-2 ">Betroffene Flurstücke:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText'] }}
              </div>
<!--Betroffene Flurstuecke Ende-->
<!-- Beschaffenheit start-->
              <div class="text-xs col-span-2">Beschaffenheit:</div>
              <div class="text-xs text-gray-500 col-span-3">
                {{ seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.beschaffenheit-group.beschaffenheit')?.getSelectedAuswahlLabelsString() }}
              </div>
              <div class="text-xs text-gray-500 col-span-2">
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="zuwegung-seilzugflaeche-modal.beschaffenheit-group.beschaffenheit-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
            />
<!-- Beschaffenheit Ende-->
<!-- Fremdobjekte start-->
            <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche"
                label="Fremdobjekte auf Fläche"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText'] }} 
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
<!-- Fremdobjekte Ende-->
            <is-vorhanden-char-and-label :fragenblock="seilzugflaeche" :ba="ba" fragesPath="zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche" label="Weitere Fremdobjekte" class="col-span-2"/>
            <div class="text-xs text-gray-500 col-span-6">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText']}}
            </div>
            <is-vorhanden-char-and-label :fragenblock="seilzugflaeche" :ba="ba" fragesPath="zuwegung-seilzugflaeche-modal.allgemein.betreiber-vorhanden" label="Betreiber Fremdobjekte" class="col-span-2"/>
            <div class="text-xs text-gray-500 col-span-6">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString() }}
            </div>
<!-- Analyse end-->
 
            <div class="grid gap-0 grid-cols-3 col-span-8 p-0 m-0">
              <div><hr class="trenner" /></div>
              <div class="mt-0.5"><hr class="trenner" /></div>
              <div><hr class="trenner" /></div>
            </div>  
            <div class="text-xs text-gray-500 col-span-8">Seilzugfläche {{ szfKey + 1 }} > Zuwegung Seilzugfläche > Geländebeschaffenheit (Zuwegung)</div>
            <div class="mt-2 text-lg md:text-lg col-span-8">Geländebeschaffenheit (Zuwegung Seilzugfläche)</div>
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Frage
              </div>
              <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Beschreibung/Eingabewerte
              </div>
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Weitere Eingaben
              </div>
              <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Bewertung
              </div>
<!-- Zuwegung Wegeart Start-->
            <div class="text-xs col-span-2">Zuwegung Wegeart</div>
            <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.zuwegung-wegeart.zuwegung-wegeart-beschreibung')?.getSelectedAuswahlLabelsString() }} 
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.zuwegung-wegeart.zuwegung-wegeart-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Wegeart Ende-->
<!-- Zuwegung Laenge Start-->
            <div class="text-xs col-span-2">Zuwegung Länge</div>
            <div class="text-xs text-gray-500 col-span-5">
              {{ 
                seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Laenge Ende-->
<!-- Zuwegung Breite-->
            <div class="text-xs col-span-2">Zuwegung Breite von-bis</div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ 
                seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breite-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breite-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Breite Ende-->
<!-- Zuwegung Hoehe-->
            <div class="text-xs col-span-2">Zuwegung Höhe</div>
            <div class="text-xs">
              Start
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs">
              Ende
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs col-span-2"></div>
            <div class="text-xs">Unterschied</div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ 
                seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] + " m" 
                  : "-" 
              }}
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Zuwegung Hoehe Ende-->
<!-- Sonstiges start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden"
              label="Sonstiges vorhanden"
              class="text-xs text-gray-500 col-span-2"
            />            
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
<!-- Sonstiges Ende-->      
             <!-- Bilder Start-->
            <div class="mt-4 text-lg md:text-lg col-span-8">Bilder Zuwegung Seilzugfläche</div>
              <div class="col-span-8 justify-items-stretch items-center gap-y-3">
                <div class="col-span-8 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"></div>
                  <oneto-five-image-div-mehrfach
                    :fragenblock="seilzugflaeche"
                    :ba="ba"
                    :immobilie="immobilie"
                    fragesPath="zuwegung-seilzugflaeche-modal.bilder-group.bilder"
                    :lang="lang"
                    class="col-span-8 ml-2"
                  />     
              </div>  
<!-- Bilder Start--> 
            </div>
  
            <!-- Allgemeine Punkte Ende-->
          </div>
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a4-page>
    <!-- ###################### -->
    <!-- Zuwegung Geländebeschaffenheit-->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Zuwegung Seilzugfläche > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung)</div>

            <div class="h-full max-h-full">
            <!-- Geländebeschaffenheit Start-->
              <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit (Zuwegung Seilzugfläche) - Fortsetzung</div>
              <div class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Frage
            </div>
            <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Beschreibung/Eingabewerte
            </div>
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Weitere Eingaben
            </div>
            <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Bewertung
            </div>
<!-- Gelälle start-->
             <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden"
                label="Gefälle vorhanden"
                class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Gefälle Ende-->
            <!-- Ausholzung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich"
              label="Ausholzung erforderlich"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']}}

            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Ausholzung Ende-->
<!-- Rodung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="zuwegung-seilzugflaeche-modal.rodung-group.rodung-erforderlich"
              label="Rodung erforderlich"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">Anzahl Bäume:</div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'zuwegung-seilzugflaeche-modal.rodung-group.anzahl-baeume')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="zuwegung-seilzugflaeche-modal.rodung-group.rodung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="zuwegung-seilzugflaeche-modal.rodung-group.rodung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
<!-- Rodung Ende-->
          </div>

          </div>
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/> 
        </div>
      </div>
    </pdf-a-4-page>                   
    <!-- ###################### --> 
    <!-- Zuwegung Seilzugfläche Ökologie Page -->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 ">Seilzugfläche {{ szfKey + 1 }} > Zuwegung Seilzugfläche > Geländebeschaffenheit (Grabenquerungen)</div>
          <div class="h-full max-h-full">
          <!-- Ökologie Start-->
            <div class="mt-4 text-lg md:text-lg col-span-8">Grabenquerungen</div>
            <div v-if="getGrabenquerungen(ba, seilzugflaeche) != null" class="col-span-8">
              <div class="grid grid-cols-8 justify-items-stretch items-center">
                <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Frage</div>
                <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
                <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
                <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
              </div>
            <div
              v-for="(grabenquerung, key) in getGrabenquerungen(ba, seilzugflaeche).slice(1)"
              :key="key"
              class="ml-2 grid grid-cols-8 justify-items-stretch items-center"
              style="
                border-style: solid;
                border-color: var(--white100) var(--white100) var(--white100) rgb(216, 215, 26);
                border-radius: 5px;
              "
            >
            <div class="text-xs col-span-1">Erforderlich?</div>
            <div class="text-xs col-span-7 text-gray-500 capitalize"> 
              {{ grabenquerung['graben-erforderlich'] }} 
            </div>
            <div class="text-xs col-span-2">Anzahl: </div>
            <div class="text-xs col-span-3 text-gray-500"> 
              {{ grabenquerung['graben-anzahl'] }} 
            </div>
            <div class="text-xs text-gray-500 col-span-2">
              {{ grabenquerung['graben-beschreibung'] }}
            </div>
            <div class="justify-self-end row-span-2">
              <PdfChip
                v-if="'plus' === grabenquerung['graben-bewertung']"
                color="green"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'o' === grabenquerung['graben-bewertung']"
                color="blue"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'minus' === grabenquerung['graben-bewertung']"
                color="yellow"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
              <PdfChip
                v-if="'x' === grabenquerung['graben-bewertung']"
                color="red"
                mangel-amount-mode
                value="1"
                pdf-mode
              />
            </div>
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                :imageObjects="grabenquerung['graben-bilder']"
                class="ml-2 col-span-8"
              >
              </oneto-five-image-div>
            </div>
            </div>
            <div v-else class="col-span-8">
              <div class="mt-2 grid grid-cols-8 justify-items-stretch items-center">
                <div
                  class="justify-center items-center col-span-8"
                  style="
                    background-color: rgb(235, 239, 240);
                    border-style: solid;
                    border-color: rgb(235, 239, 240) rgb(235, 239, 240)
                      rgb(235, 239, 240) rgb(235, 239, 240);
                    border-radius: 5px;
                  "
                >
                  <p class="text-xs text-center">Keine Grabenquerungen aufgenommen</p>
                </div>
              </div>
            </div>
          </div>
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>
    <Oekologie :ba="ba" :immobilie="immobilie" :lang="lang" :oekologie="seilzugflaeche.findFragenblockByRelativePath(ba, 'zuwegung-seilzugflaeche-modal.oekologie-group')!" :bread-crumb="`Seilzugfläche ${szfKey + 1 } > Zuwegung Seilzugfläche > Ökologie`" tab="Zuwegung Seilzugflaeche"/>
     <!-- ###################### -->
    <!-- Flaeche Zwischen Mast und Seilzugflaeche -->
    <pdf-a4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 col-span-8">Seilzugfläche {{ szfKey + 1 }} > Fläche zwischen Mast und Seilzugfläche > Allgemeine Punkte</div>
          <div class="text-xl md:text-xl font-bold">Fläche zwischen Mast und Seilzugfläche</div>
          <div class="content h-full max-h-full">
            <!-- Allgemeine Punkte Start-->
            <div class="text-lg md:text-lg col-span-8">Allgemeine Punkte (Fläche zwischen Mast und Seilzugfläche)</div>

            <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">        
            <!-- Analyse start-->
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyse </div>
              <div class="text-sm font-bold col-span-5" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Analyseergebnisse</div>
              <div class="col-span-1 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">Bewertung</div>
              <!-- Nutzungsart start-->
              <div class="text-xs col-span-2">
                {{ "Nutzungsart der Fläche" }}
              </div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche')?.getSelectedAuswahlLabelsString() }} 
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.nutzungsart-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
              <!-- Nutzungsart Ende-->
               <!-- Betroffene flurstuecke Start-->
 
              <div class="text-xs md:text-xs col-span-2 ">Betroffene Flurstücke:</div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText'] }}
              </div>
              <is-vorhanden-char-and-label :fragenblock="seilzugflaeche" :ba="ba" fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betreiber-vorhanden" label="Betreiber Fremdobjekte" class="col-span-2"/>
              <div class="text-xs text-gray-500 col-span-6">
                {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString()}}
              </div>
<!-- Betroffene flurstuecke Ende-->
              <!-- Fremdobjekte start-->
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche"
                label="Fremdobjekte auf Fläche"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-5">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText'] }} 
              </div>
              <bewertung-chip
                :fragenblock="seilzugflaeche"
                fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung"
                :ba="ba"
                :immobilie="immobilie"
                :lang="lang"
                class="justify-self-end"
              />
  
            <!-- Fremdobjekte Ende-->
            <!-- Weitere Fremdobjekte start-->
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche"
                label="Weitere Fremdobjekte:"
                class="col-span-2"
              />
              <div class="text-xs text-gray-500 col-span-6">
                {{ seilzugflaeche.findFrageByRelativePath(ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText'] }} 
              </div>
<!-- Fremdobjekte Weitere Ende-->

            <div class="grid gap-0 grid-cols-3 col-span-8 p-0 mt-4">
              <div><hr class="trenner" /></div>
              <div class="mt-0.5"><hr class="trenner" /></div>
              <div><hr class="trenner" /></div>
            </div>  
            <div class="text-xs text-gray-500 col-span-8">Seilzugfläche {{ szfKey + 1 }} > Fläche zwischen Mast und Seilzugfläche > Geländebeschaffenheit (Ausholzung/Rodung)</div>
            <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit (Fläche zwischen Mast und Seilzugfläche)</div>
              <!-- Analyse end-->
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Frage
              </div>
              <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Beschreibung/Eingabewerte
              </div>
              <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Weitere Eingaben
              </div>
              <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
                Bewertung
              </div>
            <!-- Ausholzung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich"
              label="Ausholzung erforderlich"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']}}
            </div>
            <div class="text-xs">
              Art:
            </div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()}}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Ausholzung Ende-->
            <!-- Rodung start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-erforderlich"
              label="Rodung erforderlich"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">
              Anzahl Bäume:
            </div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Rodung Ende-->
            </div>
            <!-- Allgemeine Punkte Ende-->
          </div>
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a4-page>
    <!-- ###################### -->
    <!-- Flaeche Zwischen Mast und Seilzugflaeche Geländebeschaffenheit-->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 col-span-8">Seilzugfläche {{ szfKey + 1 }} > Fläche zwischen Mast und Seilzugfläche > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)</div>
            <div class="h-full max-h-full">
            <!-- Geländebeschaffenheit Start-->
              <div class="text-lg md:text-lg col-span-8">Geländebeschaffenheit (Fläche zwischen Mast und Seilzugfläche) - Fortsetzung</div>
              <div class="mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3">
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Frage
            </div>
            <div class="text-sm font-bold col-span-3" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Beschreibung/Eingabewerte
            </div>
            <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Weitere Eingaben
            </div>
            <div class="col-span- text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
              Bewertung
            </div>
            <!-- Feuchtgebiete start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-vorhanden"
              label="Feuchtgebiete vorhanden"
              class="text-xs text-gray-500 col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Feuchtgebiete Ende-->
            <!-- Naturdenkmaeler start-->
            
            <div class="col-span-3">
              <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden"
              label="Naturdenkmäler vorhanden"
              class="text-xs text-gray-500 col-span-2"
              />
              <is-vorhanden-char-and-label
                :fragenblock="seilzugflaeche"
                :ba="ba"
                fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar"
                label="Weitere Naturdenkmäler sichtbar"
                class="text-xs text-gray-500 col-span-2"
              />
            </div>
            <div class="text-xs text-gray-500 col-span-4">
              {{ seilzugflaeche.findFrageByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText']}}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />    
            <!-- Feuchtgebiete Ende-->
            <!-- Kampfmittel start-->
            <div class="col-span-2">
               <is-vorhanden-char-and-label
                 :fragenblock="seilzugflaeche"
                 :ba="ba"
                 fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden"
                 label="Kampfmittel vorhanden"
                 class="col-span-2"
               />
               <is-vorhanden-char-and-label
                 :fragenblock="seilzugflaeche"
                 :ba="ba"
                 fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung"
                 label="Freimessung erforderlich"
                 class="col-span-2"
               /> 
            </div>
            <div class="text-xs text-gray-500 col-span-3">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText'] }}
            </div>
            <div class="text-xs">
              Art:
            </div>
            <div class="text-xs text-gray-500">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            <!-- Kampfmittel Ende-->

            <!-- Sonstiges start-->
            <is-vorhanden-char-and-label
              :fragenblock="seilzugflaeche"
              :ba="ba"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden"
              label="Sonstiges vorhanden"
              class="col-span-2"
            />
            <div class="text-xs text-gray-500 col-span-5">
              {{ seilzugflaeche.findFrageByRelativePath(ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')?.['eingabeText'] }}
            </div>
            <bewertung-chip
              :fragenblock="seilzugflaeche"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung"
              :ba="ba"
              :immobilie="immobilie"
              :lang="lang"
              class="justify-self-end"
            />
            <oneto-five-image-div-mehrfach
              :fragenblock="seilzugflaeche"
              :ba="ba"
              :immobilie="immobilie"
              fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bilder"
              :lang="lang"
              class="col-span-8 ml-2"
            />
            <!-- Sonstiges Ende-->
          </div>
          </div>
          <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>                   
    <!-- ###################### --> 
    <!-- Flaeche Zwischen Mast und Seilzugflaeche Seilzugfläche Ökologie Page -->
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 col-span-8">Seilzugfläche {{ szfKey + 1 }} > Fläche zwischen Mast und Seilzugfläche > Bilder</div>
          <div class="h-full max-h-full">
            <div class="mt-4 text-lg md:text-lg">Bilder Fläche zwischen Mast und Seilzugfläche</div>
            <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
              <div class="col-span-8 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"></div>
                <oneto-five-image-div-mehrfach
                  :fragenblock="seilzugflaeche"
                  :ba="ba"
                  :immobilie="immobilie"
                  fragesPath="flaeche-zwischen-mast-und-seilzugflaeche-modal.bilder-group.bilder"
                  :lang="lang"
                  class="col-span-8 ml-2"
                />
            </div>
            <br>
            </div>
            <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>
    <Oekologie :ba="ba" :immobilie="immobilie" :lang="lang" :oekologie="seilzugflaeche.findFragenblockByRelativePath(ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group')!" :bread-crumb="`Seilzugfläche ${ szfKey + 1 } > Fläche zwischen Mast und Seilzugfläche > Ökologie`" tab="Fläche zwischen Mast und Seilzugfläche"/>

     <!-- ###################### -->
  </span>
</template>

<script lang="ts">
  import useUser from '@/composables/useUser';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie from '@/models/immobilie.model';
  import { defineComponent, PropType } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { useIdentifierFrageFinder,getAuswahlLabel } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
  import { getPhotoUrl } from '@/utilities/get-media-url';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import Oekologie from './PageElements/Oekologie.vue';
  import PdfChip from '../Components/PdfChip.vue';
  import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
  import IsVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabelMehrfach.vue';
  import OnetoFiveImageDivMehrfach from './PageElements/OnetoFiveImageDivMehrfach.vue';
  import OnetoFiveImageDiv from './PageElements/OnetoFiveImageDiv.vue';
  import TngHeader from './PageElements/TngHeader.vue';
  import BeFooter from './PageElements/BeFooter.vue';
  import BewertungChip from './PageElements/BewertungChipMehrfach.vue';
  import { useGesamtflaechen } from './PageElements/useGesamtflaechen';

export default defineComponent( {
  name: 'Seilzugflaechen',
  components: {
    PdfA4Page,
    PdfChip,
    UniversalPdfImageRow,
    IsVorhandenCharAndLabel,
    TngHeader,
    OnetoFiveImageDivMehrfach,
    OnetoFiveImageDiv,
    BewertungChip,
    Oekologie,
    BeFooter
  },
  props: {
    ba: {
      type: Object as PropType<Bestandsaufnahme>,
      required: true,
    },
    immobilie: {
      type: Object as PropType<Immobilie>,
      required: true,
    },
    lang: {
      type: String,
      default: 'de',
    },
  },
  setup ( props: any ) {
    const { t } = useI18n( { useScope: 'global' } );
    const uUser = useUser();
    const { getSeilzugflaechen, getGrabenquerungen, getSeilzugflaechenWrappers } = useGesamtflaechen();
    return {
      user: uUser.user,
      t,
      useIdentifierFrageFinder,
      moment,
      getPhotoUrl,
      getSeilzugflaechenWrappers,
      getSeilzugflaechen,
      getAuswahlLabel,
      getGrabenquerungen,
    };
  },
} );
</script>
<style scoped>
* {
  color: rgb(23,68,81);
  font-family: var(--secondaryFont);
}

.pdf-content {
  width: 800px;
  margin: 0 auto;
  color: white;
}

.landingpage-background {
  position: absolute;
  top: 50px;
  left: 50px;
  width: 700px;
  height: 1050px;
  color: black;
}

.trenner {
  height: 3px;
  border-width: 1;
  background-color: rgb(23,68,81);
}

.content {
    height: 870px;
  }
</style>
